import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AlertModule } from '@epicuro-next/ataraxia/alert';
import { ProgressBarModule } from '@epicuro-next/ataraxia/progress-bar';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { LetDirective, PushPipe } from '@ngrx/component';

import { DeliveryPeriodModule } from '../../components/delivery-period/delivery-period.component.module';

import { InventoryOverviewComponent } from './inventory-overview.component';

@NgModule({
  imports: [
    CommonModule,
    DeliveryPeriodModule,
    ProgressBarModule,
    LetDirective,
    PushPipe,
    TooltipDirective,
    AlertModule,
  ],
  exports: [InventoryOverviewComponent],
  declarations: [InventoryOverviewComponent],
  providers: [],
})
export class InventoryOverviewModule {}
